import { render } from "./ProgramModificationsDialog.vue?vue&type=template&id=2f670fa2"
import script from "./ProgramModificationsDialog.vue?vue&type=script&lang=js"
export * from "./ProgramModificationsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__